<template>
  <div>
    
    <div class="sections sec-mt">
      <div class="container">
        <div class="row">

          <div class="col-md-6">
            <div class="training-center">
              <img v-if="row.image3" :src="row.image3" :alt="row.title3">
              <div class="content">
                <p class="head-title float-l"
                    v-html="row.title3"
                    :style="'color:'+row.titleColor3+' !important'">
                </p>
                <router-link v-if="row.button3" :to="row.redirect3" class="btn-primary float-r">
                  <div class="d-flex align-items-center">
                    {{ row.button3 }} 
                    <span class="icon-arrow-right ml-2"></span>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <div class="col-md-6">
              
              <div class="flex-vertical">
                <div v-if="row.title4" class="widget-tv">
                  <div class="widget-details" :style="'background-color:'+row.bgColor4+' !important'">
                    <p class="head-title mb-4"
                        v-html="row.title4"
                        :style="'color:'+row.titleColor4+' !important'">
                    </p>
                    <router-link v-if="row.button4" :to="row.redirect4" class="btn-primary d-inline-block">
                      <div class="d-flex align-items-center">
                        {{ row.button4 }} 
                        <span class="icon-arrow-right ml-2"></span>
                      </div>
                    </router-link>
                  </div>
                  <div class="widget-view" :style="'background-image:url('+row.image4+') !important'"></div>
                </div>
                
                <div v-if="row.title5" class="widget-tv">
                  <div class="widget-details" :style="'background-color:'+row.bgColor5+' !important'">
                    <p class="head-title mb-4"
                        v-html="row.title5"
                        :style="'color:'+row.titleColor5+' !important'">
                    </p>
                    <router-link v-if="row.button5" :to="row.redirect5" class="btn-primary d-inline-block">
                      <div class="d-flex align-items-center">
                        {{ row.button5 }} 
                        <span class="icon-arrow-right ml-2"></span>
                      </div>
                    </router-link>
                  </div>
                  <div class="widget-view" :style="'background-image:url('+row.image5+') !important'"></div>
                </div>

                <div class="widget-certification" :style="{backgroundColor:`${row.bgColor6} !important`}">
                  <img :src="row.image6" class="wc-view" alt="" />
                  <div class="wc-details pl-5">
                    <div class="bg-title mb-4" v-html="row.title6" :style="'color:'+row.titleColor6+' !important'"></div>
                    <router-link v-if="row.button6" :to="row.redirect6" class="btn-primary d-inline-block">
                      <div class="d-flex align-items-center">
                        {{ row.button6 }} 
                        <span class="icon-arrow-right ml-2"></span>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
              <!-- <div class="experts mg-b"
                  :style="'background-color:'+row.bgColor6+' !important'">
                  <div class="overlay"></div>
                  <p class="head-title"
                      v-html="row.title6"
                      :style="'color:'+row.titleColor6+' !important'">
                  </p>
                  <router-link v-if="row.button6" :to="row.redirect6" class="btn-primary">
                    {{ row.button6 }} 
                    <img src="../../assets/images/icons/arrow-right-b.svg" alt="button1"> 
                  </router-link>
                  <img v-if="row.image6" :src="row.image6" :alt="row.title6" class="img">
              </div> -->

              <!-- <div class="training mg-b"
                    :style="'background-color:'+row.bgColor7+' !important'">
                <div class="overlay"></div>
                <p class="head-title"
                    v-html="row.title7"
                    :style="'color:'+row.titleColor7+' !important'">
                </p>
                <router-link v-if="row.button7" :to="row.redirect7" class="btn-primary">
                    {{ row.button7 }} 
                    <img src="../../assets/images/icons/arrow-right-b.svg" alt="button1"> 
                </router-link>
                <img v-if="row.image7" :src="row.image7" :alt="row.title7" class="img">
              </div> -->

            <!-- <div class="certificate">
              <div class="overlay"></div>
                <p class="head-title"
                    v-html="row.title8"
                    :style="'color:'+row.titleColor8+' !important'">
                </p>
                <p class="title"
                    v-html="row.content8"
                    :style="'color:'+row.contentColor8+' !important'">
                </p>
                <router-link v-if="row.button8" :to="row.redirect8" class="btn-primary">
                    {{ row.button8 }} 
                    <img src="../../assets/images/icons/arrow-right-b.svg" alt="button1"> 
                </router-link>
                <img v-if="row.image8" :src="row.image8" :alt="row.title8" class="img">
              </div>-->
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
.widget-tv {
  display: flex;
  /* margin-bottom: 50px; */
}
.flex-vertical {
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  height: 100%;
}
.flex-vertical > div {
  width: 100%;
  position: relative;
}
.widget-tv:nth-of-type(even) {
  flex-direction: row-reverse;
}
.widget-tv > div {
  width: 50%;
}
.widget-view { 
  background-size: cover;
  background-position: center;
}
.icon-arrow-right {
  font-weight: bold;
}
.widget-details {
  padding: 30px 45px;
  background: #00766D;
}
.head-title {
  font-size: 40px;
}
.widget-certification {
  padding: 30px 80px;
  background: #000F80;
  display: flex;
}
.wc-view {
  width: 100px;
}
.bg-title {
  font-size: 40px;
  font-weight: bold;
}
</style>

<script>
export default {
  name: "Section4",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
